export class Constants {
  static readonly DATE_FMT = 'dd MMM yyyy';
  static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;
}
